import React from 'react';

const OfflineBanner: React.FC = () => {
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 1000, width: '100%',
      background: '#c62828', color: '#fff', padding: '10px 16px',
      fontSize: 13, fontWeight: 600
    }}>
      BRAK POŁĄCZENIA Z SERWEREM – INFORMACJE W APLIKACJI MOGĄ BYĆ NIEAKTUALNE
    </div>
  );
};

export default OfflineBanner;


